// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"3e0a3b17","406":"fa9de50b","449":"9545b0c5","453":"4b720780","578":"372b8f33","743":"24fb22a8","819":"5fa93b80","829":"4e4ee30f","831":"1a0969d6"}[chunkId] + ".chunk.js";
};